import React, { useEffect, useState } from 'react'
import { Dialog } from 'primereact/dialog';
import { Button } from '@mui/material'
import { CForm, CFormInput, CFormLabel, CInputGroup, CInputGroupText, CRow } from '@coreui/react';
import { useCompanySetting } from '../contexts/CompanySettingContext';
import { useCustomer } from '../contexts/CustomerContext';
import { useAuth } from '../contexts/AuthContext';
import CInput from './CInput';

const AddCustomer = ({ id, editMode, editCustomerId, setEditCustomerId, setEditMode, customerVisible, setCustomerVisible, fetchCustomers }) => {
    const { createCustomer, updateCustomer, getSingleCustomer } = useCustomer()
    const { currency } = useCompanySetting()
    const { restaurantId } = useAuth()

    const [validated, setValidated] = useState(false);
    const [customerDetails, setCustomerDetails] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        products: '',
        credits: '',
        restaurant_id: restaurantId,
        VAT: '',
        companyName: '',
    });

    const handleClose = () => {
        setCustomerVisible(false);
        setEditMode(false);
        setEditCustomerId(null);
        setCustomerDetails({
            firstName: '',
            lastName: '',
            email: '',
            phone: '',
            products: '',
            credits: '',
            restaurant_id: null,
            VAT: '',
            companyName: '',
        });
    };

    const fetchSingleCustomer = async () => {
        try {
            const data = await getSingleCustomer(id);
            setCustomerDetails(data);
        } catch (error) {
            console.error('Error fetching single customer.', error);
        }
    };

    useEffect(() => {
        if (editMode && editCustomerId) fetchSingleCustomer();
    }, [editMode, editCustomerId]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        const form = e.currentTarget;
        setValidated(true);

        if (form.checkValidity() === false) {
            e.stopPropagation();

            const firstInvalidInput = form.querySelector(':invalid');
            if (firstInvalidInput) {
                firstInvalidInput.focus();
                firstInvalidInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        } else {
            try {
                if (customerVisible && restaurantId) {
                    const data = await createCustomer(customerDetails)
                    if (!data.error) {
                        handleClose()
                        fetchCustomers()
                    }
                } else if (editMode && editCustomerId && restaurantId) {
                    const data = await updateCustomer(id, customerDetails)
                    if (!data.error) {
                        handleClose()
                        fetchCustomers()
                    }
                }
            } catch (error) {
                console.log(error)
            }
        }
    }

    return (
        <div>
            <Dialog draggable={false} header={`${customerVisible ? 'Add Customer' : 'Edit Customer'}`} visible={customerVisible || (editMode && editCustomerId !== null)} style={{ width: "29vw" }} onHide={handleClose}>
                <CForm onSubmit={handleSubmit} noValidate validated={validated}>
                    <div className='fields-container'>
                        <CRow className="mb-3 mt-3">
                            <CInput
                                label="First Name"
                                type="text"
                                className='d-flex'
                                labelClassName='w-50'
                                value={customerDetails.firstName}
                                onChange={(value) => setCustomerDetails({ ...customerDetails, firstName: value })}
                                required={true}
                                errorMessage='First name is required.'
                            />
                        </CRow>
                        <CRow className="mb-3">
                            <CInput
                                label="Last Name"
                                type="text"
                                className='d-flex'
                                labelClassName='w-50'
                                value={customerDetails.lastName}
                                onChange={(value) => setCustomerDetails({ ...customerDetails, lastName: value })}
                                required={true}
                                errorMessage='Last name is required.'
                            />
                        </CRow>
                        <CRow className="mb-2">
                            <CInput
                                label="Company Name"
                                type="text"
                                className='d-flex'
                                labelClassName='w-50'
                                value={customerDetails.companyName}
                                onChange={(value) => setCustomerDetails({ ...customerDetails, companyName: value })}
                            />
                        </CRow>
                        <CRow className="mb-3">
                            <CInput
                                label="Email"
                                type="email"
                                className='d-flex'
                                labelClassName='w-50'
                                value={customerDetails.email}
                                onChange={(value) => setCustomerDetails({ ...customerDetails, email: value })}
                                errorMessage='Please write a valid email.'
                            />
                        </CRow>
                        <CRow className="mb-3">
                            <div className='d-flex'>
                                <div className='w-50'>
                                    <CFormLabel>Phone</CFormLabel>
                                </div>
                                <div className='w-100'>
                                    <CFormInput
                                        type="text"
                                        maxlength="13"
                                        minlength="10"
                                        value={customerDetails.phone}
                                        onChange={(e) => {
                                            const inputValue = e.target.value;
                                            const numericValue = inputValue.replace(/[^\d+]/g, '');
                                            setCustomerDetails({ ...customerDetails, phone: numericValue });
                                        }}
                                        feedbackInvalid='Please write a valid phone number.'
                                    />
                                </div>
                            </div>
                        </CRow>
                        <CRow className="mb-3">
                            <div className='d-flex'>
                                <div className='w-50'>
                                    <CFormLabel>VAT</CFormLabel>
                                </div>
                                <div className='w-100'>
                                    <CFormInput
                                        type="text"
                                        maxlength="10"
                                        value={customerDetails.VAT}
                                        onChange={(e) => {
                                            const inputValue = e.target.value;
                                            const numericValue = inputValue.replace(/[^\d+]/g, '');
                                            setCustomerDetails({ ...customerDetails, VAT: numericValue });
                                        }}
                                        feedbackInvalid='Please write a valid VAT.'
                                    />
                                </div>
                            </div>
                        </CRow>
                        <CRow className="mb-3">
                            <div className='d-flex'>
                                <div className='w-50'>
                                    <CFormLabel className='w-50'>Credits</CFormLabel>
                                </div>
                                <div className='w-100'>
                                    <CInputGroup>
                                        <CInputGroupText id="basic-addon1">
                                            {currency}
                                        </CInputGroupText>
                                        <CFormInput
                                            type="number"
                                            maxLength={4}
                                            value={customerDetails.credits}
                                            onChange={(e) => {
                                                const newValue = e.target.value;
                                                if (newValue <= 1000) {
                                                    setCustomerDetails({ ...customerDetails, credits: newValue });
                                                }
                                            }}
                                            feedbackInvalid='Please write a valid credits.'
                                        />
                                    </CInputGroup>
                                </div>
                            </div>
                        </CRow>
                    </div>
                    <div className="d-flex justify-content-end button-container">
                        <div className='d-flex'>
                            <Button onClick={handleClose} fullWidth variant="contained" color="inherit" >
                                Cancel
                            </Button>
                            <Button fullWidth variant="contained" color='primary' type="submit" className='ms-3'>
                                Submit
                            </Button>
                        </div>
                    </div>
                </CForm>
            </Dialog>
        </div>
    )
}

export default AddCustomer
